import { render, staticRenderFns } from "./Servicebooking.vue?vue&type=template&id=e58982de&"
import script from "./Servicebooking.vue?vue&type=script&lang=js&"
export * from "./Servicebooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports